import { createSelector } from 'reselect';
import dayjs from 'dayjs';
import { NoEvoxImage } from '@carvana/purchase-icons';

export const getBrowserStockNumberAndOrVehicleId = createSelector(
  state => state.vehicle?.browser,
  browser => browser
);

export const getCustomer = createSelector(
  state => state.dashboard?.orderSummary?.customer,
  customer => customer
);

export const getCurrentStockNumber = createSelector(
  state => state.vehicle?.stockNumber,
  stockNumber => stockNumber
);

export const getCurrentVehicleId = createSelector(
  state => state.vehicle,
  vehicle => ({
    vehicleId: vehicle?.vehicleId || vehicle?.browser?.vehicleId
  })
);

export const getCurrentVehicleIds = createSelector(
  state => state.vehicle,
  vehicle => {
    const savedVehicleId = parseInt(vehicle?.vehicleId || 0, 10);
    const browserVehicleId = parseInt(vehicle?.browser?.vehicleId || 0, 10);
    const hasSavedVehicleId = savedVehicleId > 0;
    const hasBrowserVehicleId = browserVehicleId > 0;
    const doesBrowserVehicleIdMatchSavedVehicleId =
      hasSavedVehicleId &&
      hasBrowserVehicleId &&
      browserVehicleId === savedVehicleId;
    const isVehicleAvailable = vehicle?.lock?.isAvailable;
    const switchingVehicle = vehicle?.switchingVehicle;

    return {
      savedVehicleId,
      browserVehicleId,
      hasSavedVehicleId,
      hasBrowserVehicleId,
      doesBrowserVehicleIdMatchSavedVehicleId,
      isVehicleAvailable,
      switchingVehicle
    };
  }
);

export const getCurrentVehicleLock = createSelector(
  state => state.vehicle?.lock,
  lock => lock
);

export const getCurrentVehicleLockTime = createSelector(
  state => state.vehicle?.lock,
  lockTime => ({
    ...lockTime,
    isExpired:
      dayjs(lockTime?.expiresOn).diff(dayjs()) <= 0 ||
      lockTime?.isExpired ||
      !lockTime?.isAvailable,
    isTimerGreaterThan30Days:
      dayjs(lockTime?.expiresOn).diff(dayjs(), 'days') >= 30
  })
);

export const getVehicleYearMakeModelTrim = createSelector(
  state => state.vehicle,
  vehicle => ({
    year: vehicle?.year,
    make: vehicle?.make,
    model: vehicle?.model,
    trim: vehicle?.trim
  })
);

export const getCurrentVehicle = createSelector(
  state => state.vehicle,
  vehicle => vehicle
);

export const getVehicleTotalPrice = createSelector(
  state => state.vehicle?.totalPrice,
  totalPrice => totalPrice
);

export const getIsWIPVehicle = createSelector(
  state => state.vehicle?.inventoryType,
  inventoryType => {
    return inventoryType === 'WIP';
  }
);

export const getIsPurchasable = createSelector(
  state => state.vehicle?.purchaseType,
  purchaseType => {
    return purchaseType === 'Purchasable';
  }
);

export const getIsReservedVehicle = createSelector(
  state => state.dashboard?.status?.orderState,
  orderState => {
    return orderState === 'Reserved';
  }
);

export const getIsMarketplaceVehicle = createSelector(
  state => state?.vehicle?.isMarketplaceVehicle,
  isMarketplaceVehicle => isMarketplaceVehicle
);

export const getIsDirectDelivery = createSelector(
  state => state?.dashboard?.isDirectDelivery,
  isDirectDelivery => isDirectDelivery
);

export const getOrderState = createSelector(
  state => state?.dashboard?.status?.orderState,
  orderState => orderState
);

export const vehicleImage = ({ stockNumber } = {}) =>
  `${process.env.VEHICLE_IMAGE_CDN_URL}/${stockNumber}/post-large/${stockNumber}-edc-02-search.jpg`;

export const getVehicleImages = createSelector(
  state => state.vehicle,
  vehicle => ({
    vehicleImage: vehicleImage(vehicle),
    evoxImage: vehicle?.evoxImageUrl || NoEvoxImage
  })
);
